export const promo = {
  newInPro: "New in Pro",
  newInPlus: "New in Plus",
  newInExpert: "Test · New in Expert",
  videoTitle: "How much are your things worth?",
  videoText:
    "Film a room and we pick out everything of value we find. You get a list with estimated values and ready-made listing drafts.",
  videoBullet1: "Film the room, we list the items",
  videoBullet2: "The total shows instantly, you choose what to sell",
  videoCta: "Scan a video",
  getPro: "Get Pro",
  photoTitle: "Photograph several items at once",
  photoText:
    "Walk around and take photos, upload up to {{max}} images per round. We group the images showing the same item and set an estimated value.",
  photoCta: "Photograph the items",
  getPlus: "Get Plus",
  deepTitle: "Deep scan of a single item",
  deepText:
    "We dig deeper: exact model, condition and real sold prices. You get a price range you can trust and a finished listing text – before you set the price.",
  deepCta: "Deep scan an item",
  getExpert: "Get Expert",
} as const;
